import { RawChangelogData, ReleaseNote, ReleaseNotesQuery } from '../interfaces/release-note.interface';

export class LoadReleaseNotes {
    static readonly type = '[Release Notes] Load';
    constructor(
        public query?: ReleaseNotesQuery,
        public append = false
    ) {}
}
export class LoadRecentReleaseNote {
    static readonly type = '[Release Notes] Load recent';
}
export class LoadAdminReleaseNotes {
    static readonly type = '[Release Notes] Load admin';
    constructor(public preserveError = false) {}
}
export class GenerateReleaseNote {
    static readonly type = '[Release Notes] Generate';
    constructor(
        public version: string,
        public rawChangelogData: RawChangelogData
    ) {}
}
export class UpdateReleaseNote {
    static readonly type = '[Release Notes] Update';
    constructor(
        public id: number,
        public note: Partial<ReleaseNote>
    ) {}
}
export class PublishReleaseNote {
    static readonly type = '[Release Notes] Publish';
    constructor(public id: number) {}
}
export class UnpublishReleaseNote {
    static readonly type = '[Release Notes] Unpublish';
    constructor(public id: number) {}
}
export class DeleteReleaseNote {
    static readonly type = '[Release Notes] Delete';
    constructor(public id: number) {}
}

export class RegenerateReleaseNote {
    static readonly type = '[Release Notes] Regenerate';
    constructor(public id: number) {}
}
export class StopAdminReleaseNotesPolling {
    static readonly type = '[Release Notes] Stop admin polling';
}
